import React from "react";
import logo from "../assets/logo-profitpilot.png";
import pozadi from "../assets/prihlaseni-pozadi.jpg";

/**
 * Obal přihlášení, registrace, pozvánky a obnovy hesla.
 * Počítač: vlevo fotka domu s textem, vpravo formulář na světlém pozadí.
 * Telefon a tablet: fotka přes celou obrazovku, formulář na tmavém skle
 * (třída `sklo` v index.css — platí jen pod `lg`).
 */
export default function AuthShell({ title, subtitle, children, footer }) {
  const znacka = (
    <div className="flex items-center gap-2.5">
      <img src={logo} alt="ProfitPilot" className="h-9 w-9 shrink-0 drop-shadow" />
      <span className="text-white font-800 text-[17px] drop-shadow">
        ProfitPilot<span className="text-white/70 align-super text-[10px]">™</span>
      </span>
    </div>
  );
  return (
    <div className="min-h-[100dvh] lg:min-h-screen lg:bg-surface flex flex-col lg:flex-row relative">
      {/* Fotka: počítač vlevo přes celou výšku */}
      <div className="hidden lg:flex w-[42%] flex-col justify-between p-12 relative overflow-hidden bg-sidebar" data-testid="auth-fotka">
        <img src={pozadi} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />
        <div aria-hidden="true" className="absolute inset-0 bg-[linear-gradient(180deg,rgba(20,22,26,.55)_0%,rgba(20,22,26,.05)_30%,rgba(20,22,26,.25)_55%,rgba(20,22,26,.88)_100%)]" />
        <div className="relative">{znacka}</div>
        <div className="relative max-w-sm">
          <div className="label-up text-white/70 mb-3">Firemní systém pro technologie</div>
          <h2 className="text-white text-[26px] font-800 leading-tight">
            Od poptávky přes nabídku a realizaci až po servis.
          </h2>
          <p className="text-white/75 text-[13px] mt-4 leading-relaxed">
            Rekuperace, tepelná čerpadla, fotovoltaika, podlahové topení i klimatizace —
            všechno na jednom místě.
          </p>
          <div className="text-white/50 text-[11px] mt-10">© {new Date().getFullYear()} ProfitPilot</div>
        </div>
      </div>

      {/* Fotka: telefon a tablet přes celou obrazovku (při psaní a posunu stojí) */}
      <div aria-hidden="true" className="lg:hidden fixed inset-0 bg-sidebar overflow-hidden">
        <img src={pozadi} alt="" className="absolute inset-0 h-full w-full object-cover object-[50%_40%]" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,12,16,.45)_0%,rgba(10,12,16,.05)_35%,rgba(10,12,16,.35)_70%,rgba(10,12,16,.75)_100%)]" />
      </div>
      <div className="lg:hidden relative px-6 pt-[calc(env(safe-area-inset-top)+20px)]">{znacka}</div>

      {/* Formulář: telefon sklo ve 2/3 výšky (volné místo nad : pod = 2 : 1, ať kód
          z e-mailu není u spodní hrany), tablet uprostřed, počítač vpravo na světlém */}
      <div className="relative flex-1 flex flex-col items-center justify-center px-3.5 md:px-6 pt-6 pb-[calc(env(safe-area-inset-bottom)+14px)] md:pb-10 lg:py-10 lg:bg-surface">
        <div aria-hidden="true" className="lg:hidden flex-[2] md:flex-1" />
        <div className="sklo w-full max-w-[420px] lg:max-w-[380px] rounded-[28px] lg:rounded-none p-6 md:p-8 lg:p-0 rise" data-testid="auth-karta">
          <h1 className="text-[22px] font-800 text-ink">{title}</h1>
          {subtitle && <p className="text-[13px] text-muted mt-1.5">{subtitle}</p>}
          <div className="mt-7">{children}</div>
          {footer && <div className="mt-6 text-[12.5px] text-muted text-center">{footer}</div>}
        </div>
        <div aria-hidden="true" className="lg:hidden flex-1" />
      </div>
    </div>
  );
}
